import { render } from "./PlanPage.vue?vue&type=template&id=20b2b29a&scoped=true"
import script from "./PlanPage.vue?vue&type=script&lang=js"
export * from "./PlanPage.vue?vue&type=script&lang=js"

import "./PlanPage.vue?vue&type=style&index=0&id=20b2b29a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b2b29a"]])

export default __exports__